import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const BANNERS_QUERY = gql`
  query Banners($businessEntityUuid: UUID!) {
    banners(filter: { businessEntityUuid: $businessEntityUuid }) {
      title
      description
      type
      imageUrl
      imageSize
      raised
      dismissible
      primaryCta {
        label
        modalName
        url
      }
      secondaryCta {
        label
        modalName
        url
      }
    }
  }
`;

export function useBanners() {
  const { businessEntityUuid } = useBusinessEntity();

  const { data, loading, errors } = useQuery(BANNERS_QUERY, {
    noThrow: true,
    variables: {
      businessEntityUuid
    }
  });

  useError(errors);

  return {
    data: data?.banners || [],
    error: errors?.[0],
    loading
  };
}
